/*
 * <variant-media-sync> — moves the PDP gallery to the selected variant's image.
 *
 * Dawn's VariantSelects.updateMedia() is a no-op in this theme: it looks for a
 * slide keyed `<section id>-<media id>`, but sections/main-product.liquid keys
 * every slide and thumbnail `Slide-<section id>-<media id>`. Fixing global.js
 * would flip that behaviour back on for all ~40 product templates at once, so
 * the swap is redone here for the sections that opt in.
 */
class VariantMediaSync extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.onVariantChanged = this.onVariantChanged.bind(this);
    document.addEventListener('variant:changed', this.onVariantChanged);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:changed', this.onVariantChanged);
  }

  onVariantChanged(event) {
    const mediaId = event.detail?.variant?.featured_media?.id;
    if (!mediaId) return;

    // media-gallery.js only loads when the product has media, so the custom
    // element may still be an unupgraded HTMLElement.
    const gallery = document.getElementById(`MediaGallery-${this.sectionId}`);
    if (typeof gallery?.setActiveMedia !== 'function') return;

    // `prepend: false` — reordering the slides would shuffle the thumbnail
    // strip on every pick; we only want the active image to change.
    gallery.setActiveMedia(`Slide-${this.sectionId}-${mediaId}`, false);
  }
}

if (!customElements.get('variant-media-sync')) {
  customElements.define('variant-media-sync', VariantMediaSync);
}
